var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuTraining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.8737C4 17.7466 4.44774 16.6656 5.24473 15.8686C6.04172 15.0716 7.12268 14.6239 8.24979 14.6239H16.7494C17.8765 14.6239 18.9574 15.0716 19.7544 15.8686C20.5514 16.6656 20.9992 17.7466 20.9992 18.8737C20.9992 19.4372 20.7753 19.9777 20.3768 20.3762C19.9783 20.7747 19.4378 20.9986 18.8743 20.9986H6.12489C5.56134 20.9986 5.02086 20.7747 4.62237 20.3762C4.22387 19.9777 4 19.4372 4 18.8737Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 10.3747C14.2602 10.3747 15.6872 8.94766 15.6872 7.18734C15.6872 5.42702 14.2602 4 12.4998 4C10.7395 4 9.3125 5.42702 9.3125 7.18734C9.3125 8.94766 10.7395 10.3747 12.4998 10.3747Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTraining);
export default __webpack_public_path__ + "static/media/menuTraining.482ac85edd56b10aa98287cf16110bd7.svg";
export { ForwardRef as ReactComponent };